import type { ReactNode } from 'react'
import React from 'react'
import { Paragraph, Separator, H6 } from '@fs/zion-ui'

type SettingsSectionProps = {
  children: ReactNode
  heading: string
  description?: string
}

export default function SettingsSection({ heading, description, children }: SettingsSectionProps): JSX.Element {
  return (
    <>
      <H6>{heading}</H6>
      {description && <Paragraph size="xs">{description}</Paragraph>}
      <Separator size="nano" />
      {children}
    </>
  )
}
